import React from 'react';
import { Outlet } from 'react-router-dom';

const IRD = () => {
    return (
        <div className='ird-wrapper'>
            <Outlet />
        </div>
    );
};

export default IRD;
